<div class="badge-container">
  @if (iconName && !iconTmpl) {
    <rt-icon size="small-xx" [name]="iconName"></rt-icon>
  }
  @if (iconTmpl && !iconName) {
    <ng-container
      [ngTemplateOutlet]="iconTmpl"
      [ngTemplateOutletContext]="iconTmplContext"
    ></ng-container>
  }
  <span>{{ text }}</span>
</div>
